module.exports = {"pathContext":{"slug":"/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 751
// module chunks = 142629428675168